import React from 'react';
import { Typo } from '@ers/ui/';


export const TITLE = 'Aktualizacja Polityki Prywatności';
export const Content = () => (
    <>
        <Typo.Body className="with-margin--bottom-2">
            W dniu
            {' '}
            <Typo.Body.Bold style={{ display: 'inline' }}> 20.01.2022 </Typo.Body.Bold>
wprowadzamy zmianę w Polityce Prywatności Konta Kandydata.
            Zaktualizowaliśmy w niej zasady przepływu danych osobowych tak, żeby lepiej oddawały aktualny stan prawny w systemie.
            Dodaliśmy również system Zendesk, system do obsługi zgłoszeń od użytkowników, do listy naszych dostawców.
        </Typo.Body>
        <Typo.Body className="with-margin--bottom-2">
        Pełną treść dokumentów znajdziesz pod linkami
            {' '}
            <Typo.Link
                target="_blank"
                rel="noopener noreferrer" url="https://kandydat.erecruiter.pl/_files/Polityka_Prywatnosci_Konto_Kandydata_2022-01-20.pdf"
            >
            Polityka_Prywatnosci_Konto_Kandydata_2022-01-20.pdf
            </Typo.Link>
            <Typo.Link
                target="_blank"
                rel="noopener noreferrer" url="https://kandydat.erecruiter.pl/_files/Wykaz_dostawcow_Konto_Kandydata_2022-01-20.pdf"
                style={{ display: 'block' }}
            >
            Wykaz_dostawcow_Konto_Kandydata_2022-01-20.pdf
            </Typo.Link>
        </Typo.Body>

        <Typo.Body>Zmiana nie wymaga od Ciebie żadnej akcji poza zapoznaniem się z nowymi dokumentami.</Typo.Body>
    </>
);
